import { ENDPOINTS } from "utils/endpoints";
import { http } from "utils/http";

export const getProcess = () => http({
    url: ENDPOINTS.bpmnApi.process.getAll,
    method: 'get',

}).then((response) => (response.data))